import { useEffect } from "react";
import {
  BotIcon,
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AIChatWidget = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const allowedPaths = [
    "/",
    "/courses",
    "/about",
    "/contact",
    "/docs",
    "/mentorship",
  ];
  const isAllowedPath = allowedPaths.includes(location.pathname);
  const isHiddenPage = !isAllowedPath || location.pathname === "/ai-chat";

  const handleOpen = () => {
    navigate("/ai-chat");
  };

  if (isHiddenPage) return null;

  return (
    <button
      onClick={handleOpen}
      className="fixed z-50 p-2.5 sm:p-3.5 text-white transition-all duration-300 rounded-full shadow-lg bottom-4 right-4 bg-gradient-to-r from-primary to-orange-500 hover:shadow-xl hover:scale-105 group sm:bottom-6 sm:right-6"
      aria-label="Open AI Chat"
    >
      <BotIcon className="w-4 h-4 sm:w-5 sm:h-5" />
      <span className="absolute w-2.5 h-2.5 bg-green-500 rounded-full -top-0.5 -right-0.5 sm:w-3 sm:h-3 animate-pulse" />
    </button>
  );
};

export default AIChatWidget;
